// Map of category values to translation paths
const CATEGORY_TRANSLATION_MAP: Record<number, string> = {
  0: 'documents.table.categories.generic',
  1: 'documents.table.categories.manuals',
  2: 'documents.table.categories.service',
  3: 'documents.table.categories.sales',
  4: 'documents.table.categories.marketing',
};

export function getCategoryLabel(category: number, t: (key: string) => string): string {
  const translationPath = CATEGORY_TRANSLATION_MAP[category];
  return translationPath ? t(translationPath) : '-';
}

export const getCategoryOptions = (t: (key: string) => string) => Array.from({ length: 5 }, (_, i) => ({
  value: i,
  label: t(CATEGORY_TRANSLATION_MAP[i]!),
}))
